module.exports = "<div class=\"lui-datepicker__wrapper\"><slot></slot></div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-datepicker/theme/lui-datepicker.html
// module id = 199
// module chunks = 0 1 2